module.exports = __webpack_public_path__ + "media/images/young-multiethnic-band-performing-910b18ab93004815cd00556caf49e68c.jpeg";